<script setup lang="ts">
import { ref } from 'vue'
import IconCheck from '@/assets/icons/check-circle.svg?component'

const props = defineProps<{
  tags: Array<{ id: string; label: string }>
  value?: string[]
}>()
const emit = defineEmits<{ change: [change: string[]] }>()

const inputs = ref<HTMLInputElement[]>([])

function onChange() {
  emit(
    'change',
    inputs.value.filter((input) => input.checked).map((input) => input.id)
  )
}
</script>
<template>
  <form class="tags i-box">
    <label v-for="tag of props.tags" :key="tag.id" :for="tag.id">
      <input
        ref="inputs"
        type="checkbox"
        :id="tag.id"
        @change="onChange"
        :checked="props.value?.includes(tag.id)"
      />
      <div class="tag u-row">
        <IconCheck />
        <span>
          {{ tag.label }}
        </span>
      </div>
    </label>
  </form>
</template>
<style>
.tags .tag svg circle {
  fill: transparent;
}
.tags :checked + .tag svg circle {
  fill: var(--cl-white);
  stroke: var(--cl-orange);
  stroke-dasharray: none;
}
</style>
<style scoped>
.tags {
  padding: 6px !important;
  border: solid 1px var(--cl-black-20);
  height: unset;
  flex-wrap: wrap;
}
.tags input {
  display: none;
}
.tags label {
  margin: 6px;
}
.tags .tag {
  cursor: pointer;
  color: var(--cl-black-80);
  padding: 0 10px;
  border: solid 1px var(--cl-black-20);
  border-radius: 3px;
  margin-right: 8px;
  height: 32px;
  line-height: 14px;
  user-select: none;
}
.tags .tag svg {
  width: 16px;
  height: 16px;
  fill: var(--cl-black-40);
}
.tags .tag svg circle {
  fill: transparent;
}
.tags .tag span {
  margin-left: 4px;
}
.tags :checked + .tag {
  color: var(--cl-white);
  background: var(--cl-orange);
}
.tags :checked + .tag svg {
  fill: var(--cl-orange);
}
.tags :checked + .tag svg circle {
  fill: var(--cl-white);
  stroke: var(--cl-orange);
  stroke-dasharray: none;
}
</style>
